// extracted by mini-css-extract-plugin
export default {"container":"pDzEtaUdOs","message":"FwUGYTSRDc"};
    if(module.hot) {
      // 1650538093891
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  